export default __webpack_public_path__ + "static/media/deliland-flour-icon.667d241e.png";